<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
<!--        <div v-if="$gate.isSysAdmin()">-->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
	<div class="card card-danger ">
		<div class="card-header">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-7">
                    </div>
                    <div class="col-md-5">
                        <button @click="syncDivisionList" v-if="$gate.isSysAdmin()"  class="btn btn-danger float-right">Sync Division List</button>
                    </div>
                </div>
            </div>
		</div>
		<div class="card-body overflow-auto">
					<table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Company</th>
								<th>Name</th>
								<th>Code</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in divisions" :key="j.id">
								<td>{{j.company}}</td>
								<td>{{j.division_name}}</td>
								<td>{{j.division_code}}</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">

		</div>
	</div>
</div>
<!-- row end -->
</section>
    <!-- /.content -->

 <loading
     :show="lshow"
     :label="llabel">
 </loading>

<!-- All VUE Parts end before this comment -->
<!--        </div>-->
<!--        <div v-if="!$gate.isSysAdmin()">-->
<!--             <access-denied></access-denied>-->
<!--        </div>-->
    </div>
</template>

<script>
import loading from 'vue-full-loading';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {loading},

        created(){
        	this.getDivisions();
        },

        data(){
        	return{
        		lshow: false,
        		llabel: 'Divisions Syncing',
        		divisions: []
        	}
        },

        methods: {
        	syncDivisionList(){
        		this.lshow = true;
        		axios.post("/api/syncMasterDivisionList")
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Completed'
        			});
        		})
        		.catch(() => {
        			toast.fire({
        				icon: 'error',
        				title: 'Failed'
        			});
        		})
        		this.lshow = false;
        	},

        	getDivisions(){
        		axios.post("/api/getMasterDivisionList")
        		.then(response => {
        			this.divisions = response.data;
        		})
        	}
        }
    }
</script>
